import React from "react";
import {observer} from "mobx-react";
import {FlightsDatesSelector} from "../../../services/flight-search/dates-selection/flights-dates-selector";
import {useServices} from "../../../hooks/use-services.hook";
import {FlightDatesSelectionSkeletonsComponent} from "../flight-dates-selection-skeletons.component";
import {CalendarsInListComponent} from "./calendars-in-list.component";
import {CalendarsInSwiperComponent} from "./calendars-in-swiper.component";
import {IDropDownController} from "../../drop-down/drop-down-controller.interface";
import {EmptyDropDownMessageComponent} from "../../drop-down/empty-drop-down-message.component";
import styled from "styled-components";

const DropDownListContainerBox = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    overflow: hidden;
`

const LowFareInfoBox = styled.div`
    color: ${props => props.theme.colors.mediumShade};
    font-size: ${props => props.theme.fontSize.small};
    line-height: 1;
    padding: 4px 8px 4px 8px;
`

interface FlightDatesDropDownListComponentProps {
    datesSelector: FlightsDatesSelector;
    dropDownController: IDropDownController;
}

export const FlightDatesDropDownListComponent: React.FC<FlightDatesDropDownListComponentProps> = observer((props) => {
    const services = useServices();
    const datesSelector = props.datesSelector;
    const searchController = datesSelector.searchController;

    const renderMessages = () => {
        if(datesSelector.scheduleLoadingError) {
            return (
                <EmptyDropDownMessageComponent message={datesSelector.scheduleLoadingError}/>
            );
        }

        if(!searchController.departureOrigin
            || !searchController.departureDestination) {
            return (
                <EmptyDropDownMessageComponent message={services.language.translate('Please select departure and destination first')}/>
            )
        }

        if(datesSelector.isLoadingSchedule) {
            return (<FlightDatesSelectionSkeletonsComponent/>)
        }

        const months = datesSelector.flightsScheduledMonths;
        if(months.length === 0) {
            const msg = services.language.translationFor('There are no flights available for {route}').withParams({
                route: `${searchController.departureOrigin.stationName} - ${searchController.departureDestination.stationName}`
            });

            return (
                <EmptyDropDownMessageComponent message={msg}/>
            );
        }

        return null;
    }


    const onDateClicked = (date: Date) => {
        if(!datesSelector.isDateAvailable(date)) {
            return;
        }

        datesSelector.selectDate(date);

        if(searchController.isOneWay) {
            if(searchController.departureDate) {
                props.dropDownController.closeDropDown();
            }
        } else {
            if(searchController.departureDate && searchController.returnDate) {
                props.dropDownController.closeDropDown();
            }
        }

    }

    const renderCalendars = () => {
        if(services.application.isInMobileView) {
            return (
                <CalendarsInListComponent flightsDatesSelector={datesSelector}
                                          dropDownController={props.dropDownController}
                                          renderMessages={renderMessages}
                                          onDateClicked={onDateClicked}/>

            );
        }

        return (
            <CalendarsInSwiperComponent flightsDatesSelector={datesSelector}
                                        renderMessages={renderMessages}
                                        onDateClicked={onDateClicked}/>
        );
    }

    const renderLowFareInfoBox = () => {
        if(datesSelector.flightsScheduledMonths.length === 0) {
            return null;
        }

        return (
            <LowFareInfoBox>
                {services.language.translate('The price shown is the lowest available price for 1 person. It may differ if the booking is done for more passengers, based on availability.')}
            </LowFareInfoBox>
        );
    }

    return (
        <DropDownListContainerBox>
            {renderCalendars()}
            {renderLowFareInfoBox()}

        </DropDownListContainerBox>
    )
});
